import ApplicationComponent from "legacy/ApplicationComponent"
import PropTypes from "prop-types"
import React from "react"

class PackagingMarketing extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.btnClick = this.btnClick.bind(this)
  }

  btnClick() {
    Amplitude.trackEvent(`features:${this.props.featureKey}`)
    window.location.href = this.props.btnUrl
  }

  render() {
    return (
      <div className="container max-w-7xl">
        <div className="relative my-16 w-full">
          <div className="absolute z-10 -ml-1 -mt-1 h-full w-full rotate-6 rounded-3xl bg-gray-400 shadow-xl" />
          <div className="absolute z-10 -ml-1 -mt-1 h-full w-full rotate-3 rounded-3xl bg-gray-300 shadow-xl" />
          <div className="relative z-20 my-10 flex h-full w-full flex-col justify-between space-y-4 rounded-3xl bg-white p-10 shadow-xl">
            <div className="flex items-center justify-between">
              <h1 className="m-0 text-3xl font-bold">{this.props.header}</h1>
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.btnClick}
              >
                Request a Demo
              </button>
            </div>
            <p className="text-lg">{this.props.paragraph}</p>
            {this.props.disclaimer && <p>{this.props.disclaimer}</p>}
            <img className="w-full" alt="" src={this.props.imageUrl} />
            <p>
              Think this is a mistake?{" "}
              <a
                href="https://mayday.dockwa.com/en"
                rel="noreferrer"
                target="_blank"
              >
                Contact Support
              </a>
            </p>
          </div>
        </div>
      </div>
    )
  }
}

PackagingMarketing.propTypes = {
  featureKey: PropTypes.string.isRequired,
  btnUrl: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  paragraph: PropTypes.string.isRequired,
  disclaimer: PropTypes.string,
  imageUrl: PropTypes.string.isRequired,
}

export default PackagingMarketing
